module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": "graph-loads-per-day",
      "height": "120"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-706ff3c2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/LoadsPerDayGraph.vue
// module id = 1035
// module chunks = 0